import apiClient from "./client";

export const authApi = {
  register: async (data) => {
    try {
      const response = await apiClient.post("/auth/register", data);
      return response.data;
    } catch (error) {
      console.error(
        "Registration API error:",
        error.response?.data || error.message,
      );
      throw error;
    }
  },

  login: async (email, password) => {
    try {
      const response = await apiClient.post("/auth/login", { email, password });
      if (response.data.data.token) {
        localStorage.setItem("token", response.data.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
      }
      return response.data;
    } catch (error) {
      console.error("Login API error:", error.response?.data || error.message);
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },

  getCurrentUser: async () => {
    try {
      const response = await apiClient.get("/auth/me");
      return response.data;
    } catch (error) {
      console.error("Get current user error:", error);
      throw error;
    }
  },

  changePassword: async (oldPassword, newPassword) => {
    try {
      const response = await apiClient.post("/auth/change-password", {
        oldPassword,
        newPassword,
      });
      return response.data;
    } catch (error) {
      console.error("Change password error:", error);
      throw error;
    }
  },

  changeTemporaryPassword: async (newPassword) => {
    const response = await apiClient.post("/auth/change-temporary-password", {
      newPassword,
    });
    return response.data;
  },

  changeClientPasswordDuringSupport: async (newPassword) => {
    const response = await apiClient.post(
      "/auth/support-change-client-password",
      { newPassword },
    );
    return response.data;
  },

  forgotPassword: async (email) => {
    try {
      const response = await apiClient.post("/auth/forgot-password", { email });
      return response.data;
    } catch (error) {
      console.error("Forgot password error:", error);
      throw error;
    }
  },

  verifyEmail: async (token) => {
    const response = await apiClient.post("/auth/verify-email", { token });
    const session = response.data?.data;
    if (session?.token && session?.user) {
      localStorage.setItem("token", session.token);
      localStorage.setItem("user", JSON.stringify(session.user));
    }
    return response.data;
  },

  resendVerificationEmail: async (email) => {
    const response = await apiClient.post("/auth/resend-verification", {
      email,
    });
    return response.data;
  },

  endSupportSession: async () => {
    const response = await apiClient.post("/auth/end-support-session");
    return response.data;
  },

  resetPassword: async (token, password) => {
    const response = await apiClient.post("/auth/reset-password", {
      token,
      password,
    });
    return response.data;
  },

  getCommunicationPreferences: async () => {
    const response = await apiClient.get("/communications/preferences");
    return response.data;
  },

  updateCommunicationPreferences: async (optionalEmailUpdatesEnabled) => {
    const response = await apiClient.put("/communications/preferences", {
      optionalEmailUpdatesEnabled,
    });
    return response.data;
  },

  requestAccountDeletion: async () => {
    const response = await apiClient.post("/communications/deletion-request");
    return response.data;
  },

  cancelAccountDeletionRequest: async () => {
    const response = await apiClient.delete(
      "/communications/deletion-request",
    );
    return response.data;
  },

  unsubscribeFromOptionalEmails: async (userId, token) => {
    const response = await apiClient.post("/communications/unsubscribe", {
      userId,
      token,
    });
    return response.data;
  },
};
